function codedError(code) {
  const error = new Error(code);
  error.code = code;
  return error;
}

/**
 * A successful HTTP response is not sufficient authority to retire a
 * creating-device bootstrap fence. The server must explicitly attest that it
 * adopted this exact full snapshot.
 */
export function assertLocalDataBootstrapCompletionResponse(bodyJson, response) {
  let requestBody;
  try {
    requestBody = JSON.parse(bodyJson);
  } catch {
    throw codedError("invalid_prepared_sync_request");
  }
  if (
    requestBody?.completeLocalDataBootstrap === true &&
    response?.localDataBootstrapCompleted !== true
  ) {
    throw codedError("invalid_local_data_bootstrap_response");
  }
  return response;
}
